@for (intervention of interventionList ; track intervention.id) {
@if(intervention.dateDeRealisation && intervention.type && dateDebut && dateFin){
<tui-compass [style]="'left:' + (intervention.dateDeRealisation | datePourcentage : dateDebut : dateFin) + '%'"
    [tuiHint]="tooltip" tuiHintDirection="bottom" [class]="{
            info: intervention.type.id == 'PPC A' || intervention.type.id == 'PPC B' || intervention.type.id == 'PPC C' || intervention.type.id == 'PPC D', 
            success: intervention.type.id == 'PPC E' || intervention.type.id == 'PPC VS' || intervention.type.id == 'PPC F',
            error: !(intervention.type.id == 'PPC A' || intervention.type.id == 'PPC B' || intervention.type.id == 'PPC C' || intervention.type.id == 'PPC D' || intervention.type.id == 'PPC E' || intervention.type.id == 'PPC VS' || intervention.type.id == 'PPC F')
        }">
</tui-compass>
<ng-template #tooltip>
    <p>
        {{ intervention.type.libelle }}
    </p>
    <p>
        {{ intervention.dateDeRealisation | date:'dd/MM/yyyy' }}
    </p>
</ng-template>
}
}@empty {
<tui-compass style="left: 0%" class="info">
</tui-compass>
<tui-compass style="left: 2.5%" class="info">
</tui-compass>
<tui-compass style="left: 5%" class="info">
</tui-compass>
<tui-compass style="left: 10%" class="info">
</tui-compass>
<tui-compass style="left: 25%" class="info">
</tui-compass>
<tui-compass style="left: 40%" class="info">
</tui-compass>
<tui-compass style="left: 55%" class="info">
</tui-compass>
<tui-compass style="left: 70%" class="info">
</tui-compass>
<tui-compass style="left: 85%" class="info">
</tui-compass>
<tui-compass style="left: 100%" class="info">
</tui-compass>
}